<template>
    <div>
        <custom-input v-model.trim="firstName"
            :label="'Firstname'"
            :name="'Firstname'"
            :placeholder="'Firstname'"
            :disabled="firstName !== ''"
        />

        <custom-input v-model.trim="lastName"
            :label="'Lastname'"
            :name="'Lastname'"
            :placeholder="'Lastname'"
            :disabled="lastName !== ''"
        />

        <div class="date">
            <custom-input v-model.trim="day"
                :label="'Date'"
                :name="'date'"
                :placeholder="'Date'"
                disabled
            />

            <custom-input v-model.trim="month"
                :label="'Month'"
                :name="'Month'"
                :placeholder="'Month'"
                disabled
            />

            <custom-input v-model.trim="year"
                :label="'Year'"
                :name="'Year'"
                :placeholder="'Year'"
                disabled
            />
        </div>
    </div>
</template>

<script>
import customInput from '@webapp/components/form/custom-input.vue';

export default {
    name: 'user-infos',
    components: {
        customInput,
    },
    props: {
        requirement: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            day: '',
            month: '',
            year: '',
        };
    },
    computed: {
        firstName() {
            return this.requirement.config.prefill.user.firstName || '';
        },

        lastName() {
            return this.requirement.config.prefill.user.lastName || '';
        },
    },
    watch: {
        firstName(newValue) {
            this.$emit('updateFirstName', newValue);
        },
        lastName(newValue) {
            this.$emit('updateLastName', newValue);
        },
    },
    mounted() {
        // Emit the initial values when the component is mounted
        this.$emit('updateFirstName', this.firstName);
        this.$emit('updateLastName', this.lastName);

        const today = new Date();

        this.day = String(today.getDate()).padStart(2, '0');
        this.month = this.getMonthName(today.getMonth());
        this.year = today.getFullYear().toString();
    },
    methods: {
        getMonthName(monthIndex) {
            const monthNames = [
                this.$t('global.calendar.months.january'),
                this.$t('global.calendar.months.february'),
                this.$t('global.calendar.months.march'),
                this.$t('global.calendar.months.april'),
                this.$t('global.calendar.months.may'),
                this.$t('global.calendar.months.june'),
                this.$t('global.calendar.months.july'),
                this.$t('global.calendar.months.august'),
                this.$t('global.calendar.months.september'),
                this.$t('global.calendar.months.october'),
                this.$t('global.calendar.months.november'),
                this.$t('global.calendar.months.december'),
            ];

            return monthNames[monthIndex];
        },
    },
};
</script>

<style lang="scss" scoped>
.date {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
}
</style>